import { render, staticRenderFns } from "./ConflictResolver.vue?vue&type=template&id=c68b784c&"
import script from "./ConflictResolver.vue?vue&type=script&lang=js&"
export * from "./ConflictResolver.vue?vue&type=script&lang=js&"
import style0 from "./ConflictResolver.vue?vue&type=style&index=0&id=c68b784c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports